import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '@app/services/config.service';
import { NotificationService } from './notification.service';
import { ConfigMetrics } from '@common/enums/ConfigMetrics';

@Injectable({ providedIn: 'root' })
export class QuarterService {

  constructor(
    private readonly configService: ConfigService,
    private readonly notificationService: NotificationService
  ) {}

  getQuartersOfYear(): Observable<{ label: string; value: string }[]> {
    return this.configService.getConfigByMetric(ConfigMetrics.AlertsQuarters).pipe(
      map(config => {
        const currentQtr = this.notificationService.getCurrentQuarter();
        const past = this.getPreviousQuartersBasedonCount(config.config_value['past_quarter_count'], currentQtr);
        const future = this.getFutureQuartersBasedonCount(config.config_value['future_quarter_count'], currentQtr);
        return [...past, { label: currentQtr, value: currentQtr }, ...future];
      })
    );
  }

  getPreviousQuartersBasedonCount(count: number, currentQtr: string): { label: string; value: string }[] {
    const quarters = [];
    const [yearStr, quarterStr] = currentQtr.split('-Q');
    let year = Number(yearStr);
    let quarter = Number(quarterStr);
    for (let i = 0; i < count; i++) {
      quarter--;
      if (quarter === 0) {
        quarter = 4;
        year--;
      }
      quarters.push({ label: `${year}-Q${quarter}`, value: `${year}-Q${quarter}` });
    }
    return quarters.reverse();
  }

  getFutureQuartersBasedonCount(count: number, currentQtr: string): { label: string; value: string }[] {
    const quarters = [];
    const [yearStr, quarterStr] = currentQtr.split('-Q');
    let year = Number(yearStr);
    let quarter = Number(quarterStr);
    for (let i = 0; i < count; i++) {
      quarter++;
      if (quarter === 5) {
        quarter = 1;
        year++;
      }
      quarters.push({ label: `${year}-Q${quarter}`, value: `${year}-Q${quarter}` });
    }
    return quarters;
  }
}
